module.exports = __webpack_public_path__ + "static/media/header-desktop.5b827fd0.jpg";